import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import MaterialEdit         from "./MaterialEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchMaterials, deleteMaterial,
} from "Actions/Admin/Program/MaterialActions";



/**
 * The Program Material List
 */
class MaterialList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchMaterials(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteMaterial(elemID);
        this.fetch();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, params, route, withDetails    } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "programMaterialID", elemID, "materialName");

        return <Main withDetails={withDetails}>
            <Header message="MATERIALS_NAME" icon="material" route={route}>
                <ActionList data={data} onAction={this.startAction} useAssign />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="MATERIALS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="materialName"    message="GENERAL_NAME"     grow="2" bigMobile />
                        <TableHeader field="className"       message="CLASSES_SINGULAR" grow="2" bigMobile />
                        <TableHeader field="matCategoryName" message="GENERAL_CATEGORY" maxWidth="120" />
                        <TableHeader field="position"        message="GENERAL_POSITION" maxWidth="90"  align="center" hideMobile />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.programMaterialID} elemID={elem.programMaterialID}>
                            <TableCell message={elem.materialName}    circle={elem.statusColor} />
                            <TableCell message={elem.classString}     />
                            <TableCell message={elem.matCategoryName} />
                            <TableCell message={elem.position}        />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="MATERIALS_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="MATERIALS_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <MaterialEdit
                open={action.isVCE}
                elemID={elemID}
                programID={params.programID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="MATERIALS_DELETE_TITLE"
                message="MATERIALS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchMaterials : PropTypes.func.isRequired,
        deleteMaterial : PropTypes.func.isRequired,
        data           : PropTypes.object.isRequired,
        type           : PropTypes.string.isRequired,
        params         : PropTypes.object.isRequired,
        route          : PropTypes.string.isRequired,
        withDetails    : PropTypes.bool.isRequired,
        elemID         : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.programMaterial,
        };
    }
}

export default connect(MaterialList.mapStateToProps, {
    fetchMaterials, deleteMaterial,
})(MaterialList);
